import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Tooltip,
  Typography,
  Button,
  IconButton,
  TextField,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseProductGroup } from "../../basic-information/productGroup/UseProductGroup";
import { useNavigate, useLocation } from "react-router-dom";
import DeleteRow from "../../components/DeleteRow";
import { rsProgress, rsParentChildsNew } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CustomPagination from "../../components/CustomPagination";
import { useSnackbar } from "notistack";

export default function GroupChilds(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const navigate = useNavigate();
  const { deleteGroup, getGroupByID } = UseProductGroup();
  const [filtered, setFiltered] = useState([]);
  const [filt, setFilt] = useState([]);
  const [parentID, setParentID] = useRecoilState(rsParentChildsNew);
  const [searchSubGroup, setSearchSubGroup] = useState(
    location.state && location.state.searchSubGroup
      ? location.state.searchSubGroup
      : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [childPageScrollTo, setChildPageScrollTo] = useState(
    location.state && location.state.childPageScrollTo
      ? location.state.childPageScrollTo
      : undefined
  );
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    if (parentID.id) {
      setProgress(true);
      getGroupByID(parentID.id, (current) => {
        setProgress(false);
        setFiltered(current.groups);
      });
    } else {
      setSearchSubGroup("");
      setFiltered([]);
    }
  }, [parentID.id]);

  useEffect(() => {
    setFilt([
      {
        columnField: "faName",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  useEffect(() => {
    if (location.state && location.state.searchGroup) {
      props.setSearchToShow(location.state.searchGroup);
    }
    if (location.state && location.state.PageScrollTo) {
      props.setPageScrollTo(location.state.PageScrollTo);
    }
  }, [location]);

  const newFuncChilds = () => {
    if (!parentID.id) {
      enqueueSnackbar("ابتدا سرگروه را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return;
    }
    return navigate("/productgroups/addChildproductgroup", {
      state: {
        id: parentID.id,
        searchGroup: props.searchToShow,
        searchSubGroup: searchSubGroup,
        PageScrollTo: props.PageScrollTo,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 60,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "faName",
      headerName: "نام فارسی",
      width: props.Offer ? 300 : 220,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.faName}
          </Typography>
        );
      },
    },
    {
      field: "description",
      headerName: "توضیحات",
      width: 80,
      headerAlign: "center",
      hide: props.ProductGroup ? true : false,
      align: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.description ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 80,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            {props.ProductGroup ? (
              <Box>
                <Button
                  fontSize="small"
                  sx={{ bgcolor: "secondary" }}
                  variant="contained"
                  onClick={() => {
                    props.setGroupID(cellValues.row.id, cellValues.row.faName);
                  }}
                >
                  انتخاب
                </Button>
              </Box>
            ) : (
              <Box>
                <Tooltip title="Delete">
                  <IconButton
                    onClick={() => {
                      setDeleteState({
                        show: true,
                        name: cellValues.row.faName,
                        id: cellValues.row.id,
                      });
                    }}
                  >
                    <DeleteIcon sx={{ color: "MyColor.main" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Edit">
                  <IconButton
                    onClick={() => {
                      return navigate("/productgroups/editproductgroup", {
                        state: {
                          model: cellValues.row,
                          id: cellValues.row.id,
                          searchGroup: props.searchToShow,
                          searchSubGroup: searchSubGroup,
                          PageScrollTo: parentID.scrolParent,
                          childPageScrollTo: cellValues.api.getScrollPosition(),
                        },
                      });
                    }}
                  >
                    <EditIcon sx={{ color: "MyColor.main" }} />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
          </Box>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "100%" }}>
      <TextField
        placeholder="جستجو زیرگروه"
        size="small"
        sx={{ mb: 2 }}
        variant="outlined"
        value={searchState}
        inputProps={{ "aria-label": "search" }}
        onChange={(evt) => {
          if (evt.target.value == "") {
            setSearchSubGroup("");
          }
          setSearchState(evt.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setSearchSubGroup(searchState);
          }
        }}
      />
      <DataGrid
        disableVirtualization
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        filterModel={{
          items: filt,
        }}
        sx={{
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "&  .MuiDataGrid-columnHeader:focus-within": {
            outline: "none",
          },
          "&  .MuiDataGrid-cell:focus-within ": {
            outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
          },
          width: "100% !important",
          "& .muirtl-s1v7zr-MuiDataGrid-virtualScrollerRenderZone": {
            width: "100% !Important",
          },
          "&  .MuiDataGrid-filterIcon": {
            display: "none",
          },
          "& .MuiDataGrid-cell:hover": {
            color: "primary.main",
          },
          "& .MuiDataGrid-virtualScrollerRenderZone": {
            width: "100% !important",
          },
          "& .secondary": {
            width: "100%",
            backgroundColor: "#e9d8f2 !important",
          },
        }}
        getRowClassName={(params) => {
          if (params.row.id == props.groupID) {
            return "secondary";
          }
        }}
        columns={columns}
        rows={filtered ? filtered : []}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        hideFooter={props.ProductGroup ? true : false}
        disableMultipleColumnsFiltering={false}
        componentsProps={{
          pagination: {
            scrollTo:
              location.state && location.state.childPageScrollTo
                ? location.state.childPageScrollTo
                : childPageScrollTo,
            ChildGroup: newFuncChilds,
            nofab: true,
          },
        }}
      />

      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"زیرگروه"}
        callback={() => {
          setProgress(true);
          deleteGroup(deleteState.id, () => {
            getGroupByID(parentID.id, (current) => {
              setProgress(false);
              setFiltered(current.groups);
            });
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
